import { UserCompanyNestedSelectDto, UserCompanyPatchDto } from '@@types/api.types';
import { ApiErrorWrapper, useApi } from '@hooks/api.hook';
import { useMutation } from '@tanstack/react-query';
import { removeEmptyStrings } from '@utils/form-validator.util';
import { queryClient } from './client';
import { queryKeys } from './keys';

export const useUpdateUserCompany = () => {
  const { apiPatch } = useApi();

  const onSuccess = () => {
    queryClient.invalidateQueries({ queryKey: queryKeys.userCompanies.getCompanyUsers });
  };

  return useMutation<UserCompanyNestedSelectDto, ApiErrorWrapper, { id: string; data: UserCompanyPatchDto }>({
    mutationFn: async ({ id, data }) => {
      const cleanedData = removeEmptyStrings(data);
      return await apiPatch<UserCompanyNestedSelectDto>({
        path: `/v1/user/companies/${id}`,
        body: cleanedData,
      });
    },
    onSuccess,
  });
};

export const useDeleteUserCompany = () => {
  const { apiDelete } = useApi();

  const onSuccess = () => {
    queryClient.invalidateQueries({ queryKey: queryKeys.userCompanies.getCompanyUsers });
  };

  return useMutation<UserCompanyNestedSelectDto, Error, { id: string }>({
    mutationFn: async ({ id }) => {
      return await apiDelete({
        path: `/v1/user/companies/${id}`,
      });
    },
    onSuccess,
  });
};
